"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["en"] = "en";
    Locale["da_DK"] = "da-DK";
    Locale["de_AT"] = "de-AT";
    Locale["de_CH"] = "de-CH";
    Locale["de_DE"] = "de-DE";
    Locale["de_LU"] = "de-LU";
    Locale["en_AU"] = "en-AU";
    Locale["en_CA"] = "en-CA";
    Locale["en_GB"] = "en-GB";
    Locale["en_IE"] = "en-IE";
    Locale["es_ES"] = "es-ES";
    Locale["es_MX"] = "es-MX";
    Locale["fi_FI"] = "fi-FI";
    Locale["fr_BE"] = "fr-BE";
    Locale["fr_CA"] = "fr-CA";
    Locale["fr_CH"] = "fr-CH";
    Locale["fr_FR"] = "fr-FR";
    Locale["fr_LU"] = "fr-LU";
    Locale["it_CH"] = "it-CH";
    Locale["it_IT"] = "it-IT";
    Locale["ja_JP"] = "ja-JP";
    Locale["ko_KR"] = "ko-KR";
    Locale["nb_NO"] = "nb-NO";
    Locale["nl_BE"] = "nl-BE";
    Locale["nl_NL"] = "nl-NL";
    Locale["nn_NO"] = "nn-NO";
    Locale["pl_PL"] = "pl-PL";
    Locale["pt_BR"] = "pt-BR";
    Locale["ru_RU"] = "ru-RU";
    Locale["sv_SE"] = "sv-SE";
    Locale["tr_TR"] = "tr-TR";
    Locale["es_BO"] = "es-BO";
    Locale["es_CL"] = "es-CL";
    Locale["en_KY"] = "en-KY";
    Locale["es_CR"] = "es-CR";
    Locale["nl_CW"] = "nl-CW";
    Locale["en_CW"] = "en-CW";
    Locale["es_DO"] = "es-DO";
    Locale["es_EC"] = "es-EC";
    Locale["es_SV"] = "es-SV";
    Locale["fr_GF"] = "fr-GF";
    Locale["fr_GP"] = "fr-GP";
    Locale["es_GT"] = "es-GT";
    Locale["en_JM"] = "en-JM";
    Locale["fr_MQ"] = "fr-MQ";
    Locale["es_PA"] = "es-PA";
    Locale["es_PY"] = "es-PY";
    Locale["es_PE"] = "es-PE";
    Locale["nl_SX"] = "nl-SX";
    Locale["en_SX"] = "en-SX";
    Locale["en_LC"] = "en-LC";
    Locale["en_TT"] = "en-TT";
    Locale["es_UY"] = "es-UY";
    Locale["bg_BG"] = "bg-BG";
    Locale["es_CO"] = "es-CO";
    Locale["en_CY"] = "en-CY";
    Locale["en_EE"] = "en-EE";
    Locale["hr_HR"] = "hr-HR";
    Locale["hu_HU"] = "hu-HU";
    Locale["en_IN"] = "en-IN";
    Locale["lt_LT"] = "lt-LT";
    Locale["ru_LT"] = "ru-LT";
    Locale["lv_LV"] = "lv-LV";
    Locale["ru_LV"] = "ru-LV";
    Locale["en_NZ"] = "en-NZ";
    Locale["ro_RO"] = "ro-RO";
    Locale["sv_SK"] = "sv-SK";
    Locale["th_TH"] = "th-TH";
    Locale["en_TH"] = "en-TH";
    Locale["it_VA"] = "it-VA";
    Locale["es_VE"] = "es-VE";
    Locale["vi_VN"] = "vi-VN";
})(Locale = exports.Locale || (exports.Locale = {}));
